import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@material-ui/core';
import defaultLocales from 'globals/locales/default';
import { numberOfCustomersOptionList } from 'globals/locales/select-options';
import FsSimpleInput from 'ui-elements/form-elements/FsDefaultInput';
import { FsFormFullWidthContainer } from 'ui-elements/form-elements/FsFormFullWidthContainer/FsFormFullWidthContainer';
import FsDefaultSelect from 'ui-elements/form-elements/FsDefaultSelect';

interface FsBillingInfoFormProps {
  onChange?: (isValid: boolean) => void;
}

const FsEnterpriseForm: React.FC<FsBillingInfoFormProps> = ({ onChange }) => {
  const formEl = useRef<HTMLFormElement>(null);
  const [numberOfCustomers, setNumberOfCustomers] = useState<string>('');
  const [suggestedPrice, setSuggestedPrice] = useState<string>('');
  const [projectInfo, setProjectInfo] = useState<string>('');

  const fields = [
    {
      name: 'number-of-customers',
      isSelect: true,
      options: numberOfCustomersOptionList,
      value: numberOfCustomers,
      label: defaultLocales.howManyCustomersQuestion,
      onChange: (e: React.ChangeEvent<HTMLInputElement>): void => {
        setNumberOfCustomers(e.target?.value);
      },
      required: true,
    },
    {
      name: 'suggested-price',
      value: suggestedPrice,
      label: defaultLocales.suggestedPriceCaption,
      onChange: (e: React.ChangeEvent<HTMLInputElement>): void => {
        setSuggestedPrice(e.target?.value);
      },
      required: true,
    },
    {
      name: 'project-info',
      value: projectInfo,
      label: defaultLocales.tellAboutYourProjectCaption,
      onChange: (e: React.ChangeEvent<HTMLInputElement>): void => {
        setProjectInfo(e.target?.value);
      },
    },
  ];

  useEffect(() => {
    const isDefaultFormValid = !!formEl?.current?.checkValidity();
    if (onChange) onChange(isDefaultFormValid);
  }, [numberOfCustomers, suggestedPrice, projectInfo, onChange]);

  return (
    <Box>
      <form ref={formEl}>
        {fields.map(({ name, isSelect, options, ...otherProps }) => (
          <FsFormFullWidthContainer key={name}>
            {name === 'number-of-customers' && isSelect && options && (
              <FsDefaultSelect
                {...{ ...otherProps, name, options }}
                fullWidth
                fsVariant="outlined"
              />
            )}
            {name === 'suggested-price' && (
              <FsSimpleInput
                {...{ ...otherProps, name }}
                fsVariant="outlined"
                fullWidth
              />
            )}
            {name === 'project-info' && (
              <FsSimpleInput
                {...{ ...otherProps, name }}
                fsVariant="outlined"
                fullWidth
                multiline
                rows={3}
              />
            )}
          </FsFormFullWidthContainer>
        ))}
      </form>
    </Box>
  );
};

export default FsEnterpriseForm;
